export interface ICollectionModelProperty {
    name: string;
    type: string;
    required: boolean;
    'link-collection-name'?: string;
}
